export default {
  wrongAccountTitle: {
    id: 'review_form_error_403_title',
    defaultMessage: 'Oops. Wrong account.',
  },
  unauthorizedTitle: {
    id: 'review_form_error_401_title',
    defaultMessage: "Oops. You're not connected.",
  },
  genericTitle: {
    id: 'review_form_error_generic_title',
    defaultMessage: 'Uh oh. We broke something.',
  },
  wrongAccountMessage: {
    id: 'review_form_error_403_message_changed',
    defaultMessage:
      'You are currently logged in as {mail}. Please log out, then log back in with the correct details.',
  },
  unauthorizedMessage: {
    id: 'review_form_error_401_message',
    defaultMessage:
      'You are not logged in. If you have a token it is unused or incorrect.',
  },
  genericMessage: {
    id: 'review_form_error_generic_message',
    defaultMessage:
      'Oops! An error has occurred. Thank you for trying again later.',
  },
  signOut: {
    id: 'review_form_sign_out',
    defaultMessage: 'Sign Out',
  },
  signIn: {
    id: 'review_form_sign_in',
    defaultMessage: 'Sign In',
  },
  mainRateTitle: {
    id: 'review_funnel_question_main_rate_title',
    defaultMessage: 'How was your {model} order?',
  },
  mainRateSubtitle: {
    id: 'review_funnel_question_main_rate_subtitle',
    defaultMessage: 'We want to hear from you so we can improve.',
  },
  overallPerformanceTitle: {
    id: 'review_overall_performance_title',
    defaultMessage: 'Overall performance',
  },
  aestheticAppearanceTitle: {
    id: 'review_aesthetic_appearance_title',
    defaultMessage: 'Appearance',
  },
  batteryTitle: {
    id: 'review_battery_title',
    defaultMessage: 'Battery',
  },
  cameraTitle: {
    id: 'review_camera_title',
    defaultMessage: 'Lens & Camera',
  },
  accessoriesTitle: {
    id: 'review_accessories_title',
    defaultMessage: 'Accessories',
  },
  shippingTitle: {
    id: 'review_shipping_title',
    defaultMessage: 'Shipping',
  },
  packagingCleanlinessTitle: {
    id: 'review_packaging_cleanliness_title',
    defaultMessage: 'Packaging & cleanliness',
  },
  validationText: {
    id: 'review_form_validation_text',
    defaultMessage: 'No response, no opinion.',
  },
  fileInputMaxSizeError: {
    id: 'review_collection_photo_picker_error_too_big',
    defaultMessage: 'Upload a file under 10 MB.',
  },
} as const
